export default {
  GET_MACHINE_TRAIN_HEALTH_REQUEST: 'GET_MACHINE_TRAIN_HEALTH_REQUEST',
  GET_MACHINE_TRAIN_HEALTH_SUCCESS: 'GET_MACHINE_TRAIN_HEALTH_SUCCESS',
  GET_MACHINE_TRAIN_HEALTH_FAILURE: 'GET_MACHINE_TRAIN_HEALTH_FAILURE',

  SUBMIT_ANALYST_ASSESSMENT_REQUEST: 'SUBMIT_ANALYST_ASSESSMENT_REQUEST',
  SUBMIT_ANALYST_ASSESSMENT_SUCCESS: 'SUBMIT_ANALYST_ASSESSMENT_SUCCESS',
  SUBMIT_ANALYST_ASSESSMENT_FAILURE: 'SUBMIT_ANALYST_ASSESSMENT_FAILURE'
};
